import React from "react";
// react plugin that creates an input with badges
import {globals,article_form} from '../Globals/Globals'
import {useSelector, useDispatch } from 'react-redux';
import { closeModalArticle } from '../../redux/modalSlice'; 
import { updateArticle, addArticle } from '../../redux/articleSlice';
import {Button, Container } from "reactstrap";
import { openModal } from "../../redux/modalSlice";

// core components
import {DsDynamicForm} from "datasync-dynamic-form";
import "../../Components/Modal/Modal.css";

const ArticleFormDialog = () => {
  const {articleModal} = useSelector((state) => state.modal);
  const user_foreign_keys = useSelector((state) => state.auth.user_guid);
  const dispatch = useDispatch();
  const {isAdmin} = useSelector((state) => state.auth);
  const {isReadOnly} = useSelector((state) => state.modal);

  React.useEffect(() => {
    console.log("articleModal -> ",articleModal);
    console.log("articleModal.activeObject -> ",articleModal.activeObject);
    console.log("user_foreign_keys ->",user_foreign_keys);

    return function cleanup() {
      document.body.classList.remove("discover");
    };
  });

  return (
      <>
        <div className="main modal-overlay">
          <Button className="modal-top-right-close-button" onClick={()=>{dispatch(closeModalArticle())}}>Fermer</Button>
          <div className="dialog-container">
            <Container>
              {articleModal.activeObject &&
              <h1>{articleModal.activeObject.data_blob.data_tier.article_title}</h1>}
              {articleModal.activeObject===null &&
              <h1>{"<Nouvel article>"}</h1>}
              
              <DsDynamicForm
                col_lg={12}
                datasync_url = {globals.datasync_service.url}
                form = {article_form}
                company_guid = {globals.datasync.platform_company_guid}
                table_guid= {globals.datasync.pf_articles_table_guid}
                onFormSaved = {(saved_data) => {dispatch(openModal({title:"Article enregistré"})); console.log("ArticleFormDialog::saved_data ->",saved_data);dispatch(addArticle(saved_data)); dispatch(closeModalArticle());}}
                //Let us update the articl
                onFormUpdated = {(updated_data) => {dispatch(openModal({title:"Article modifié"})); console.log("ArticleFormDialog::updated_data ->",updated_data); dispatch(updateArticle(updated_data)); dispatch(closeModalArticle());}}
                onFormFailed = {() => {if (globals.parameters.save_failed_alert) dispatch(openModal({title:"Erreur de sauvegarde de l'article"}))}}
                clearOnSave = {true}
                clearOnUpdate = {true}
                sticky_button = {true}
                custom_button_handler = {() => {dispatch(closeModalArticle())}}
                custom_button_caption = {"Fermer"}
                //---
                datasync_object = {articleModal.activeObject}
                data_blob = {articleModal.activeObject?articleModal.activeObject.data_blob:null}
                show_hidden = {isAdmin}
                foreign_keys = {articleModal.activeObject==null?{"user_guid":user_foreign_keys}:null}
                read_only = {isReadOnly}
              />
            </Container>
          </div>
        </div>
      </>
    );
  }

export default ArticleFormDialog;
